<template>
	<header class="header-global">
		<base-nav
			class="navbar-main"
			transparent
			type
			effect="light"
			expand
		>
			<div
				class="row"
				slot="content-header"
				slot-scope="{ closeMenu }"
			>
				<div
					class="col-10 collapse-brand text-white"
					v-if="isLogin"
				>
					<img
						src="/img/brand/219983.png"
						class="avatar"
						alt="Avatar"
					/>
					{{ userName }}
				</div>
				<div class="col collapse-close">
					<close-button @click="closeMenu"></close-button>
				</div>
				<div class="col-12 collapse-menu">
					<a
						@click="goHome"
						rel="noopener"
					>
						<span class="btn-inner--icon">
							<i class="fa fa-home mr-2"></i>
						</span>
						<span class="nav-link-inner--text">Home</span>
					</a>
				</div>

				<div
					class="col-12 collapse-menu"
					v-if="!isLogin"
				>
					<a
						@click="login"
						rel="noopener"
					>
						<span class="btn-inner--icon">
							<i class="fa fa-sign-in mr-2"></i>
						</span>
						<span class="nav-link-inner--text">Login</span>
					</a>
				</div>

				<div
					class="col-12 collapse-menu"
					v-if="!isLogin"
				>
					<a
						@click="goRegistration"
						rel="noopener"
					>
						<span class="btn-inner--icon">
							<i class="fa fa-address-card-o mr-2"></i>
						</span>
						<span class="nav-link-inner--text">Register</span>
					</a>
				</div>

				<div
					class="col-12 collapse-menu"
					v-if="isLogin"
				>
					<div class="divider dropdown-divider"></div>
					<a
						href="#"
						@click="profile"
					>
						<i class="fa fa-user-o"></i> Profile
					</a>
				</div>
				<div
					class="col-12 collapse-menu"
					v-if="isLogin"
				>
					<div class="divider dropdown-divider"></div>
					<a
						href="#"
						@click="register"
					>
						<i class="fa fa-sliders"></i> Password
					</a>
				</div>
				<div
					class="col-12 collapse-menu"
					v-if="isLogin"
				>
					<div class="divider dropdown-divider"></div>
					<a
						href="#"
						@click="logout"
					>
						<i class="fa fa-sign-out"></i> Logout
					</a>
				</div>
			</div>

			<ul class="navbar-nav align-items-lg-left">
				<li class="nav-item d-none d-lg-block ml-lg-4">
					<a
						href="#"
						@click="goHome"
						rel="noopener"
						class="text-white"
					>
						<span class="btn-inner--icon">
							<i class="fa fa-home mr-2"></i>
						</span>
						<span class="nav-link-inner--text">Home</span>
					</a>
				</li>
				<li
					class="nav-item d-none d-lg-block ml-lg-4"
					v-if="!isLogin"
				>
					<a
						href="#"
						@click="login"
						rel="noopener"
						class="text-white"
					>
						<span class="btn-inner--icon">
							<i class="fa fa-sign-in mr-2"></i>
						</span>
						<span class="nav-link-inner--text">Login</span>
					</a>
				</li>
				<li
					class="nav-item d-none d-lg-block ml-lg-4"
					v-if="!isLogin"
				>
					<a
						href="#"
						@click="goRegistration"
						rel="noopener"
						class="text-white"
					>
						<span class="btn-inner--icon">
							<i class="fa fa-address-card-o mr-2"></i>
						</span>
						<span class="nav-link-inner--text">Register</span>
					</a>
				</li>
				<li
					class="nav-item d-none d-lg-block ml-lg-4"
					v-if="isLogin"
				>
					<a
						href="#"
						@click="logout"
						rel="noopener"
						class="text-white"
					>
						<span class="btn-inner--icon">
							<i class="fa fa-sign-out"></i>
						</span>
						<span class="nav-link-inner--text">Logout</span>
					</a>
				</li>
			</ul>
			<base-dropdown
				class="nav-item ml-lg-auto d-none d-lg-block"
				menu-classes="dropdown-menu-xl"
				style=""
				v-if="isLogin"
			>
				<a
					slot="title"
					href="#"
					class="nav-link"
					data-toggle="dropdown"
					role="button"
				>
					<a
						href="#"
						data-toggle="dropdown"
						class="nav-item nav-link dropdown-toggle user-action text-white"
					>
						<img
							src="/img/brand/219983.png"
							class="avatar"
							alt="Avatar"
						/>
						<b>
							{{ userName }}
						</b>
						<b class="caret"></b>
					</a>
				</a>
				<div class="dropdown-menu-inner">
					<a
						href="#"
						class="dropdown-item"
						@click="profile"
					>
						<i class="fa fa-user-o"></i> Profile
					</a>
					<a
						href="#"
						class="dropdown-item"
						@click="register"
					>
						<i class="fa fa-sliders"></i> Password
					</a>
					<div class="divider dropdown-divider"></div>
					<a
						href="#"
						class="dropdown-item"
						@click="logout"
					>
						<i class="fa fa-sign-out"></i> Logout
					</a>
				</div>
			</base-dropdown>
		</base-nav>

		<register-user ref="modal-register"></register-user>
		<login-user ref="modal-login"></login-user>
		<registration
			ref="modal-registration"
			title="Profile Subjek Pajak"
			code="1"
		></registration>
		<registration-user
			ref="modal-registration-user"
			title="Registrasi User"
		></registration-user>
	</header>
</template>
<script>
	import BaseNav from "@/components/BaseNav"
	import BaseDropdown from "@/components/BaseDropdown"
	import CloseButton from "@/components/CloseButton"
	import RegisterUser from "@/views/GlobalPage/RegisterUser"
	import LoginUser from "@/views/GlobalPage/LoginUser"
	import Registration from "@/views/GlobalPage/Regstration.vue"
	import RegistrationUser from "@/views/GlobalPage/Regstration.vue"

	export default {
		components: {
			BaseNav,
			CloseButton,
			BaseDropdown,
			RegisterUser,
			LoginUser,
			Registration,
			RegistrationUser,
		},
		computed: {
			isLogin() {
				return this.$store.state.auth.status.loggedIn
			},
			userName() {
				if (this.$store.state.auth.status.loggedIn)
					return (
						this.$store.state.auth.user.name +
						"(" +
						this.$store.state.auth.user.email +
						")"
					)
				return "User"
			},
		},
		methods: {
			goRegistration() {
				this.$refs["modal-registration-user"].showModal()
				if (this.isLogin) {
					this.$refs["modal-registration-user"].updateMode(
						this.$store.state.auth.user
					)
				}
			},
			register() {
				this.$refs["modal-register"].showModal()
			},
			goHome() {
				this.$router.push("/home")
			},
			login() {
				this.$refs["modal-login"].showModal()
			},
			profile() {
				this.$refs["modal-registration"].showModal()
				if (this.isLogin) {
					this.$refs["modal-registration"].updateMode(
						this.$store.state.auth.user
					)
				}
			},
			changePassword() {},
			async logout() {
				await this.$store.dispatch("auth/logout")

				this.$router.push("/home")
			},
		},
	}
</script>
<style>
	.navbar img {
		border-radius: 50%;
		width: 36px;
		height: 36px;
		margin-right: 10px;
	}

	.navbar .navbar-brand {
		color: #efe5ff;
		padding-left: 0;
		padding-right: 50px;
		font-size: 24px;
	}

	.navbar .navbar-brand:hover,
	.navbar .navbar-brand:focus {
		color: #fff;
	}

	.navbar .navbar-brand i {
		font-size: 25px;
		margin-right: 5px;
	}

	.search-box {
		position: relative;
	}

	.search-box input {
		padding-right: 35px;
		min-height: 38px;
		border: none;
		background: #faf7fd;
		border-radius: 3px !important;
	}

	.search-box input:focus {
		background: #fff;
		box-shadow: none;
	}

	.search-box .input-group-addon {
		min-width: 35px;
		border: none;
		background: transparent;
		position: absolute;
		right: 0;
		z-index: 9;
		padding: 10px 7px;
		height: 100%;
	}

	.search-box i {
		color: #a0a5b1;
		font-size: 19px;
	}

	.navbar .nav-item i {
		font-size: 18px;
	}

	.navbar .nav-item span {
		position: relative;
		top: 3px;
	}

	.navbar .navbar-nav > a {
		color: #efe5ff;
		padding: 8px 15px;
		font-size: 14px;
	}

	.navbar .navbar-nav > a:hover,
	.navbar .navbar-nav > a:focus {
		color: #fff;
		text-shadow: 0 0 4px rgba(255, 255, 255, 0.3);
	}

	.navbar .navbar-nav > a > i {
		display: block;
		text-align: center;
	}

	.navbar .dropdown-item i {
		font-size: 16px;
		min-width: 22px;
	}

	.navbar .dropdown-item .material-icons {
		font-size: 21px;
		line-height: 16px;
		vertical-align: middle;
		margin-top: -2px;
	}

	.navbar .nav-item.open > a,
	.navbar .nav-item.open > a:hover,
	.navbar .nav-item.open > a:focus {
		color: #fff;
		background: none !important;
	}

	.navbar .dropdown-menu {
		border-radius: 1px;
		border-color: #e5e5e5;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	}

	.navbar .dropdown-menu a {
		color: #777 !important;
		padding: 8px 20px;
		line-height: normal;
		font-size: 15px;
	}

	.navbar .dropdown-menu a:hover,
	.navbar .dropdown-menu a:focus {
		color: #333 !important;
		background: transparent !important;
	}

	.navbar .navbar-nav .active a,
	.navbar .navbar-nav .active a:hover,
	.navbar .navbar-nav .active a:focus {
		color: #fff;
		text-shadow: 0 0 4px rgba(255, 255, 255, 0.2);
		background: transparent !important;
	}

	.navbar .navbar-nav .user-action {
		padding: 9px 15px;
		font-size: 15px;
		color: #fff !important;
	}

	.navbar .navbar-toggle {
		border-color: #fff;
	}

	.navbar .navbar-toggle .icon-bar {
		background: #fff;
	}

	.navbar .navbar-toggle:focus,
	.navbar .navbar-toggle:hover {
		background: transparent;
	}

	.navbar .navbar-nav .open .dropdown-menu {
		background: #faf7fd;
		border-radius: 1px;
		border-color: #faf7fd;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	}

	.navbar .divider {
		background-color: #e9ecef !important;
	}

	@media (min-width: 1200px) {
		.form-inline .input-group {
			width: 350px;
			margin-left: 30px;
		}
	}

	@media (max-width: 1199px) {
		.navbar .navbar-nav > a > i {
			display: inline-block;
			text-align: right;
			min-width: 30px;
			position: relative;
			top: 4px;
		}

		.navbar .navbar-collapse {
			border: none;
			box-shadow: none;
			padding: 0;
		}

		.navbar .navbar-form {
			border: none;
			display: block;
			margin: 10px 0;
			padding: 0;
		}

		.navbar .navbar-nav {
			margin: 8px 0;
		}

		.navbar .navbar-toggle {
			margin-right: 0;
		}

		.input-group {
			width: 100%;
		}
	}
</style>
